import { isApplicationMode } from '@repo/env-variables';
import { createStore, persist } from '@repo/zustand';

interface State {
  dismissedGuids: string[];
  dismiss: (guid: string) => void;
}

// Persisted: a dismissed news item stays hidden across reloads; a new item
// delivered on the RSS feed has a new guid, so it shows up again.
export const useNewsStore = createStore<State>({
  name: 'NewsStore',
  isDev: isApplicationMode('dev'),
})(
  persist(
    (set, get) => ({
      dismissedGuids: [],
      dismiss: (guid: string) => {
        if (get().dismissedGuids.includes(guid)) return;
        set({ dismissedGuids: [...get().dismissedGuids, guid] });
      },
    }),
    { name: 'news-storage-v1' }
  )
);
